var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhapli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3035 34.2039C10.3035 35.2482 10.3615 36.2787 10.4752 37.2906C10.517 37.6572 10.5657 38.0193 10.6214 38.3813C13.2059 37.1513 14.9529 34.8003 14.9529 32.1012C14.9529 29.7085 13.5817 27.5919 11.4728 26.283C10.7119 28.7894 10.3035 31.4491 10.3035 34.2039Z",
    fill: "#FAF5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1384 49.6836L15.1244 49.6928C17.6463 53.3504 21.0405 56.3582 25.0055 58.4191C25.0797 58.2404 25.147 58.0547 25.205 57.8667C25.3047 57.5511 25.3813 57.2262 25.4347 56.892C25.4625 56.7179 25.4857 56.5415 25.4996 56.3652C25.5159 56.1702 25.5251 55.9729 25.5251 55.7734C25.5251 54.9889 25.3952 54.2323 25.1539 53.5268C24.219 50.7743 21.6136 48.7947 18.5488 48.7947C17.6185 48.7947 16.7322 48.978 15.9225 49.3053C15.6534 49.4167 15.3912 49.542 15.1384 49.6836Z",
    fill: "#FAF5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5924 8.44049C24.2656 9.9467 20.4352 12.5158 17.4122 15.8346C18.6279 16.8697 20.2055 17.4963 21.9316 17.4963C25.7829 17.4963 28.908 14.3725 28.908 10.5176C28.908 9.79352 28.7966 9.09728 28.5924 8.44049Z",
    fill: "#FAF5E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2646 61.3851C36.0256 61.4524 36.7959 61.4849 37.5754 61.4849C41.3895 61.4849 45.0204 60.7005 48.3171 59.2848C47.2128 56.9129 45.0296 55.9869 42.2247 55.9869C38.7331 55.9869 35.7727 58.0408 35.2646 61.3851Z",
    fill: "#FAF5E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.248 7.34044C41.197 7.68624 41.1691 8.04132 41.1691 8.40337C41.1691 12.2559 44.2919 15.382 48.1455 15.382C50.4702 15.382 52.528 14.2448 53.7971 12.495L53.9038 12.3534C50.2846 9.64036 45.967 7.80692 41.2712 7.17334L41.248 7.34044Z",
    fill: "#FAF5E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5442 49.853C55.5442 51.3175 55.913 52.5661 56.674 53.6754C59.6924 50.7164 62.0263 47.0565 63.4114 42.9602C63.1191 42.9301 62.8221 42.9138 62.5205 42.9138C62.0727 42.9138 61.6342 42.9486 61.2097 43.0159V42.9974C60.4835 43.1366 59.7945 43.3873 59.168 43.7331C57.0081 44.919 55.5442 47.2143 55.5442 49.853Z",
    fill: "#FAF5E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4485 23.166C60.0147 24.0757 59.7734 25.0923 59.7734 26.1668C59.7734 27.1067 59.959 28.0049 60.2954 28.8241C61.1004 30.7759 62.7639 32.2844 64.8148 32.8739C64.6199 28.8195 63.5411 24.9971 61.7663 21.5948C61.7315 21.5275 61.6944 21.4602 61.6596 21.3929C61.5807 21.4788 61.5041 21.5623 61.4299 21.6505C61.1724 21.9545 60.938 22.2818 60.7362 22.6276C60.6318 22.8016 60.5367 22.9826 60.4485 23.166Z",
    fill: "#FAF5E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6128 32.6279C68.3761 27.8796 67.0746 23.412 64.9402 19.4597C62.5737 15.0687 59.1795 11.3136 55.0823 8.5124C51.4747 6.0477 47.3218 4.32334 42.8442 3.55979C41.132 3.26737 39.3711 3.1142 37.5754 3.1142C33.6754 3.1142 29.9425 3.83365 26.5042 5.14491C22.3026 6.74859 18.5395 9.23649 15.4423 12.3812C11.9668 15.9065 9.32896 20.2557 7.84646 25.1108C6.96949 27.9863 6.4962 31.0405 6.4962 34.2038C6.4962 35.8214 6.61917 37.4111 6.85814 38.9637C7.62375 43.9488 9.57256 48.544 12.4123 52.4523C15.0873 56.1377 18.5511 59.2105 22.5578 61.4268C26.474 63.5945 30.9076 64.9382 35.6266 65.2306C36.2715 65.2701 36.9211 65.291 37.5754 65.291C41.6865 65.291 45.6096 64.4926 49.2011 63.0421C53.1034 61.4686 56.6112 59.1246 59.5391 56.1981C62.8336 52.9048 65.3949 48.8736 66.9493 44.3759C68.0536 41.1894 68.6522 37.7662 68.6522 34.2038C68.6522 33.7628 68.6429 33.3265 68.6244 32.8902C68.6221 32.802 68.6174 32.7161 68.6128 32.6279Z",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4751 37.2904C10.5169 37.6571 10.5656 38.0192 10.6213 38.3812C11.257 42.5354 12.8323 46.381 15.1245 49.6928C17.6463 53.3504 21.0405 56.3582 25.0055 58.4191C28.1213 60.0413 31.5897 61.0787 35.2647 61.3851C36.0256 61.4524 36.7959 61.4849 37.5754 61.4849C41.3896 61.4849 45.0204 60.7004 48.3172 59.2847C51.4492 57.9433 54.2773 56.0309 56.6739 53.6753C59.6923 50.7163 62.0263 47.0564 63.4113 42.9602C64.3416 40.2123 64.8474 37.2672 64.8474 34.2037C64.8474 33.7581 64.8358 33.3149 64.8149 32.8739C64.6201 28.8195 63.5412 24.9971 61.7664 21.5948",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5924 8.44049C24.2655 9.9467 20.4352 12.5158 17.4122 15.8346C14.7163 18.7936 12.6607 22.3514 11.4729 26.2829C10.7119 28.7893 10.3036 31.449 10.3036 34.2038C10.3036 35.2482 10.3616 36.2786 10.4753 37.2905",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6595 21.3929C59.7664 17.8374 57.1076 14.7508 53.9037 12.3534C50.2844 9.64034 45.9668 7.8069 41.2711 7.17332C40.0624 7.00622 38.8281 6.92267 37.5753 6.92267C34.427 6.92267 31.404 7.45646 28.5921 8.43816",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7665 21.5948C61.7317 21.5275 61.6946 21.4602 61.6598 21.3929",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2481 7.34045C41.197 7.68625 41.1692 8.04134 41.1692 8.40339C41.1692 12.2559 44.2919 15.3821 48.1455 15.3821C50.4702 15.3821 52.5281 14.2449 53.7971 12.495",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1034 8.47997C55.115 8.31519 55.1219 8.14809 55.1219 7.97867C55.1219 4.12613 51.9992 1 48.1456 1C46.039 1 44.1505 1.93529 42.8699 3.41132",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4122 15.8346C18.6279 16.8697 20.2055 17.4963 21.9316 17.4963C25.7829 17.4963 28.908 14.3725 28.908 10.5176C28.908 9.79352 28.7966 9.09728 28.5924 8.44049",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4949 5.12173C25.4346 4.28856 24.1192 3.75478 22.6715 3.65498C18.8272 3.39041 15.4979 6.29374 15.2334 10.137C15.1801 10.9145 15.2566 11.6687 15.4422 12.3812C15.4608 12.4532 15.4794 12.5228 15.5002 12.5924",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5147 38.4323C10.5495 38.416 10.5866 38.3998 10.6214 38.3812C13.2059 37.1512 14.9529 34.8002 14.9529 32.1011C14.9529 29.7084 13.5817 27.5918 11.4728 26.2828C11.4079 26.2434 11.3429 26.2039 11.278 26.1668",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97644 25.1086C7.93236 25.1086 7.8906 25.1086 7.84652 25.1086C4.05558 25.1759 1.00011 28.2765 1.00011 32.0873C1.00011 35.5429 3.51271 38.4138 6.81179 38.9685",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2174 58.7138C13.3264 61.0996 15.7438 62.7543 18.5487 62.7543C20.0173 62.7543 21.3792 62.2995 22.5044 61.5243",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8905 57.8668C11.981 58.1592 12.0924 58.44 12.2177 58.7139",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6305 54.866C11.5911 55.163 11.5702 55.4671 11.5702 55.7734C11.5702 56.5045 11.6839 57.2077 11.8904 57.8668",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7998 53.9932C11.7256 54.2787 11.6676 54.5688 11.6304 54.8659",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4124 52.4523C12.1502 52.9351 11.9437 53.4503 11.7999 53.9933",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9225 49.3053C15.6534 49.4167 15.3912 49.542 15.1383 49.6836",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1538 53.5268C24.2188 50.7743 21.6134 48.7947 18.5487 48.7947C17.6183 48.7947 16.7321 48.978 15.9224 49.3053",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5251 55.7734C25.5251 54.989 25.3952 54.2324 25.1539 53.5269",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4996 56.3652C25.5159 56.1702 25.5251 55.973 25.5251 55.7734",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4347 56.8929C25.4626 56.7186 25.4858 56.5419 25.4998 56.3652",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.205 57.8668C25.3048 57.5511 25.3813 57.2262 25.4347 56.892",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0051 58.4201C25.0795 58.2411 25.1469 58.0551 25.205 57.8668",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8701 65.848C36.9675 68.264 39.4012 69.9443 42.2247 69.9443C46.0528 69.9443 49.1616 66.8599 49.201 63.0422C49.2034 63.0166 49.2034 62.9911 49.2034 62.9656",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5894 65.1216C35.601 65.1587 35.6126 65.1935 35.6265 65.2307C35.6984 65.4419 35.7796 65.6484 35.8701 65.848",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3567 59.3707C48.3428 59.3428 48.3312 59.3127 48.3172 59.2848C47.2129 56.9129 45.0297 55.9869 42.2248 55.9869C38.7332 55.9869 35.7728 58.0408 35.2647 61.3851C35.2578 61.4176 35.2531 61.4524 35.2485 61.4849",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.516 56.1865C59.516 56.1865 59.5322 56.1934 59.5392 56.1981C60.3605 56.588 61.2769 56.6878 62.2444 56.7319C66.0933 56.9036 69.3529 53.9214 69.5246 50.0712C69.6267 47.8107 68.6407 45.7521 67.0283 44.4037",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.168 43.733C57.008 44.919 55.5441 47.2142 55.5441 49.853C55.5441 51.3174 55.913 52.566 56.6739 53.6754C56.718 53.7404 56.7644 53.8053 56.8131 53.8703",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2097 42.9974C60.4835 43.1366 59.7945 43.3873 59.1681 43.7331",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6875 42.995C63.597 42.9811 63.5042 42.9718 63.4114 42.9602C63.1191 42.9301 62.8221 42.9138 62.5205 42.9138C62.0728 42.9138 61.6343 42.9486 61.2097 43.0159",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2958 28.8242C61.1008 30.776 62.7643 32.2845 64.8152 32.874L64.8361 32.8809",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4485 23.166C60.0146 24.0758 59.7733 25.0923 59.7733 26.1668C59.7733 27.1068 59.959 28.0049 60.2954 28.8241",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7362 22.6276C60.6316 22.802 60.5363 22.9833 60.448 23.167",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4301 21.6506C61.1725 21.9546 60.9382 22.2818 60.7364 22.6276",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6595 21.3929C61.5807 21.4788 61.5041 21.5623 61.4299 21.6505",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M69.397 32.6256C71.9375 31.5836 73.7262 29.084 73.7262 26.1668C73.7262 22.3119 70.6034 19.1881 66.7499 19.1881C66.1698 19.1881 65.6061 19.2577 65.0678 19.3923",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8719 32.8163C69.0508 32.7605 69.2251 32.6954 69.3971 32.6256",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4776 32.9299C68.5264 32.9159 68.5752 32.9043 68.624 32.8904C68.7077 32.8671 68.7913 32.8416 68.8727 32.816",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2034 26.7144C49.2034 26.7144 52.231 28.0698 52.1962 33.1454",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1455 28.8705C48.1455 28.8705 50.4702 30.1841 50.048 33.1455",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5394 34.8165C20.5394 34.8165 18.76 37.7987 21.718 40.3353",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1311 36.5339C22.1311 36.5339 21.9223 38.0285 22.667 38.9708",
    stroke: "#FAF5E1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhapli);
export default __webpack_public_path__ + "static/media/dhapli.18e587a381942d3f21c63cadc5c579bc.svg";
export { ForwardRef as ReactComponent };